import { render, staticRenderFns } from "./costing.vue?vue&type=template&id=27e7f5e4&"
import script from "./costing.vue?vue&type=script&lang=js&"
export * from "./costing.vue?vue&type=script&lang=js&"
import style0 from "./costing.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports